<template>
  <div>
    <table class="table w-100">
      <tr v-if="!loaded">
        <td>
          <loading-button :loading="loading" @submit="loadData" block="">Load Revision History</loading-button>
        </td>
      </tr>
      <thead v-if="loaded">
        <tr>
          <th>What</th>
          <th>Old</th>
          <th>New</th>
          <th>Who</th>
          <th>When</th>
        </tr>
      </thead>
      <tbody v-if="loaded">
        <tr v-for="revision in data">
          <td>{{ revision.key }}</td>
          <td>{{revision.old_value}}</td>
          <td>{{revision.new_value}}</td>
          <td>{{ revision.user ? revision.user.name_full : 'N/A' }}</td>
          <td>{{ revision.created_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserRevisions',
  data () {
    return {
      loaded: false,
      loading: false,
      data: []
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.axios.get('/revisions/user/' + this.id).then(rsp => {
        this.data = rsp.data.data
        this.loading = false
        this.loaded = true
      })
    }
  },
  props: ['id']
}
</script>

<style scoped>

</style>